import fitvids from "fitvids";
import LazyLoad from "vanilla-lazyload";
import Swiper from "swiper/bundle";

const Common = {
  init() {
    new LazyLoad();

    Common.events();
  },

  events() {
    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Fitvids
    fitvids();

    // Video.
    $(".flex-video__overlay").on("click", function () {
      $(this).parent().addClass("playing").find("video")[0].play();
    });

    //tabs
    const buttons = document.querySelectorAll(".tabs__btn");
    const sections = document.querySelectorAll(".tabs__content");

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        buttons.forEach((btn) => {
          btn.classList.remove("active");
        });
        btn.classList.add("active");
        const id = btn.id;
        sections.forEach((section) => {
          section.classList.remove("active");
        });
        const req = document.getElementsByClassName(`tabs__content${id}`);
        req[0].classList.add("active");
      });
    });

    //play stop video
    $(".product-video__video").click(function () {
      if ($(this).hasClass("open")) {
        $("iframe", this)[0].contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*"
        );
        $(this).addClass("pause").removeClass("open");
      } else if ($(this).hasClass("pause")) {
        $("iframe", this)[0].contentWindow.postMessage(
          '{"event":"command","func":"' + "playVideo" + '","args":""}',
          "*"
        );
        $(this).addClass("open").removeClass("pause");
      } else if (
        !$(this).hasClass("open") ||
        !$(this).hasClass("pause") ||
        !$(this).hasClass("played")
      ) {
        $("iframe", this)[0].src +=
          "&amp;rel=0&amp;autoplay=1&amp;controls=0&amp;playsinline=1&amp;enablejsapi=1&version=3&playerapiid=ytplayer";
        $(this).addClass("open played");
      }
    });

    //read more
    // $("a.read-more").click(function(e){
    //  e.preventDefault();
    //  $(this).addClass('hide');
    //  $(this).siblings('.long-content').slideDown();
    //  $(this).siblings('.read-less').removeClass('hide');
    // });

    //read less
    // $("a.read-less").click(function(e){
    //  e.preventDefault();
    //  $(this).addClass('hide');
    //  $(this).siblings('.long-content').slideUp();
    //  $(this).siblings('.read-more').removeClass('hide');
    // });

    //read more 2
    $(".seo-txt .read-more, .content__top .read-more").click(function (e) {
      e.preventDefault();
      $(this).addClass("hide");
      $(this).siblings("p").slideDown();
      $(this).siblings(".read-less").removeClass("hide");
    });

    //read less 2
    $(".seo-txt .read-less, .content__top .read-less").click(function (e) {
      e.preventDefault();
      $(this).addClass("hide");
      $(this).siblings("p:not(:first-child)").slideUp();
      $(this).siblings(".read-more").removeClass("hide");
    });
  },
};

export default Common;
